export default __webpack_public_path__ + "static/media/ic_flag_english.e31fe89f.svg";